export const GET_HEADMANS = 'GET_HEADMANS'
export const GET_HEADMAN_BY_ID = 'GET_HEADMAN_BY_ID'
export const GET_USERS = 'GET_USERS'
export const HEADMAN_WAS_UPDATED = 'HEADMAN_WAS_UPDATED'
export const CLEAR_HEADMAN = 'CLEAR_HEADMAN'
export const CLEAR_HEADMANS = 'CLEAR_HEADMANS'
export const GET_HEADMANS_FILTERS = 'GET_HEADMANS_FILTERS'
